import { useOrgSettings } from './useOrgSettings';
import { useSubscription } from './useSubscription';

/**
 * Extras (manual/one-off invoicing) access has three distinct states callers
 * must render differently:
 * - `enabled` (planAllows && orgSells): normal affordance, original behavior.
 * - `!planAllows`: show the affordance with a lock icon that opens the
 *   upgrade dialog — this is an upsell, the org hasn't chosen not to sell
 *   extras, their plan just doesn't allow it yet.
 * - `planAllows && !orgSells`: hide the affordance — the org's own choice
 *   (made in onboarding/settings) to not sell extras, not an upsell target.
 *
 * A FREE/PRO org can have `sellsExtras=true` (set during onboarding before
 * ever upgrading, or left over from a downgrade) — gating on `sellsExtras`
 * alone shows an affordance the server will 403 (FEATURE_LOCKED). Gating on
 * `allowsExtras` alone would ignore the org's own choice to not sell extras.
 */
export function useExtrasAccess(): { planAllows: boolean; orgSells: boolean; enabled: boolean } {
  const { data: subscription } = useSubscription();
  const { data: orgSettings } = useOrgSettings();
  const planAllows = Boolean(subscription?.plan?.allowsExtras);
  const orgSells = orgSettings?.settings.sellsExtras === true;
  return { planAllows, orgSells, enabled: planAllows && orgSells };
}
